import { SessionFilterViewProps } from './model'
import React, { useEffect } from 'react'
import { UserFilter } from '../../apps/professional-app/fa/common/userFilter/UserFilter'
import { useUserFilter } from '../../apps/professional-app/fa/common/userFilter/hooks'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSessionFilterUserIds, setSessionFilterUserIds } from '../../store/sessionFilter/sessionFilter'
import { useSearchParams } from 'react-router-dom'

export const SessionUserFilter: React.FC<SessionFilterViewProps> = ({ filterType, disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const sessionFilterUserIds = useAppSelector(selectSessionFilterUserIds)
  const { sessionSharingAvailable, selectedUserIds, setSelectedUserIds, resetUserFilter, isLoading: usersLoading, userFilterValues } = useUserFilter(filterType)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const userSelectOptions = userFilterValues.filter((option) => sessionFilterUserIds.includes(option.id))
    if (userSelectOptions.length) {
      setSelectedUserIds(userSelectOptions.map((option) => option.id))
    } else {
      resetUserFilter()
    }
  }, [userFilterValues, sessionFilterUserIds, setSelectedUserIds, resetUserFilter])

  const handleUserIdsChanged = (ids: string[]) => {
    const selectedIds = ids.includes('{all}') && !selectedUserIds.includes('{all}') ? ['{all}'] : ids.filter((id) => id !== '{all}')
    setSelectedUserIds(selectedIds)
    searchParams.set('userId', selectedIds.join(','))
    searchParams.delete('filterId')
    onFilterChanged?.(searchParams)
    dispatch(setSessionFilterUserIds(selectedIds))
  }

  return (
    <UserFilter
      userFilterValues={userFilterValues}
      selectedUserIds={selectedUserIds}
      onSelectedChanged={handleUserIdsChanged}
      disabled={usersLoading || disabled}
      sessionSharingAvailable={sessionSharingAvailable}
    />
  )
}
